// src/components/e-sign/VerticalStepperComponent.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography, Box } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
  },
  stepper: {
    display: 'flex',
    flexDirection: 'column',
  },
  step: {
    display: 'flex',
    marginBottom: theme.spacing(4),
    position: 'relative',
  },
  stepConnector: {
    position: 'absolute',
    left: '12px',
    top: '28px',
    bottom: '-28px',
    width: '2px',
    backgroundColor: '#e0e0e0',
    zIndex: 1,
  },
  stepCircle: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    border: '2px solid #ccc',
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: theme.spacing(2),
    zIndex: 2,
  },
  stepCircleActive: {
    border: '2px solid #0b7adb',
    backgroundColor: 'white',
  },
  stepCircleCompleted: {
    border: '2px solid #0b7adb',
    backgroundColor: 'white',
  },
  stepContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  stepLabel: {
    fontWeight: 'bold',
    marginBottom: '2px',
  },
  stepLabelActive: {
    color: '#0b7adb',
  },
  checkIcon: {
    color: '#0b7adb',
    fontSize: '20px',
  },
  activeCircleInner: {
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    backgroundColor: '#0b7adb',
  },
}));

export default function VerticalStepperComponent({ steps, activeStep }) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className={classes.stepper}>
        {steps.map((step, index) => {
          const isActive = activeStep === index;
          const isCompleted = step.completed || index < activeStep;
          
          return (
            <div className={classes.step} key={index}>
              {index < steps.length - 1 && (
                <div 
                  className={classes.stepConnector} 
                  style={{ 
                    backgroundColor: isCompleted ? '#0b7adb' : '#e0e0e0',
                  }}
                />
              )}
              
              <div 
                className={`${classes.stepCircle} ${isActive ? classes.stepCircleActive : ''} ${isCompleted ? classes.stepCircleCompleted : ''}`}
              >
                {isCompleted ? (
                  <CheckCircleIcon className={classes.checkIcon} />
                ) : isActive ? (
                  <div className={classes.activeCircleInner} />
                ) : null}
              </div>
              
              <div className={classes.stepContent}>
                <Typography 
                  variant="body1" 
                  className={`${classes.stepLabel} ${isActive ? classes.stepLabelActive : ''}`}
                  color={isCompleted ? 'primary' : 'textPrimary'}
                >
                  {step.label}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}